import Component from '../../components/Component';
import Timeline from '../../components/Timeline';
import Loading from '../../components/Loading';

import query from './query';
import keys from './keys';
import { fillMissingDates } from '../../helpers/fillEmptyDates';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }

    render() {
        const { t } = this.props;

        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <Timeline
                data={fillMissingDates(this.state.data)}
                direct_parent_id={this.props.direct_parent_id}
                error={this.state.error}
                forceRun={this.forceRun}
                header={t('discover.overview.page_performance.header')}
                keys={keys(t)}
                content_id={this.props.content_id}
                parent_id={this.props.parent_id}
                hasRightAxis
            />
        );
    }
}

export default withTranslation()(Summary);
